import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MessageBus } from '../../services/message/message-bus.service';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { LinkLabelComponent } from '../core/labels/link-label.component';

@Component({
  selector: 'app-account-locked',
  imports: [
    ButtonComponent,
    RouterModule,
    ActionRowComponent,
    LinkLabelComponent,
  ],
  template: `
    <div class="tw-px-4 tw-pt-4 tw-pb-2 ">
      <div class="tw-font-bold tw-py-4">Account locked</div>
      <p class="tw-pb-8">
        Your account is locked due to three invalid login attempts. To unlock
        your account and reset your password, please click "Unlock account" to
        proceed to the next screen. For assistance, please contact
        <app-link-label (click)="messagBus.publish('show-technical-support')"
          >technical&nbsp;support</app-link-label
        >.
      </p>
    </div>
    <div class="tw-flex tw-justify-end tw-pr-7 tw-pb-10">
      <app-action-row>
        <app-button
          right1
          label="Unlock account"
          routerLink="/login/forgot-password"
        />
        <app-button right2 label="Back" routerLink="/login" emphasis="Low" />
      </app-action-row>
    </div>
  `,
  styles: ``,
})
export class AccountLockedComponent extends BaseComponent {  protected messagBus = inject(MessageBus);

}
